import {BaseFirebaseModel} from '../bases/baseFirebaseModel';

export class Message extends BaseFirebaseModel {
	// createdAt: firebase.firestore.FieldValue;
	sender: string = '';
	isImage: boolean = false;
	readers: string[] = [];
	fileUrl: string = '';

	constructor(obj?: object) {
		super();
		Object.assign(this, obj);
	}

	_content: string = '';

	get content(): string {
		if (this._content) {
			return this._content;
		}
		return '';
	}

	set content(value: string) {
		this._content = this.replaceStringEmoji(value);
	}

	clone(): Message {
		this.content.replace(/(\r\n|\r|\n){2,}/g, '$1\n');
		this.createdAt = new Date();
		const clone = new Message(this);
		this.content = '';
		return clone;
	}

	test() {
		return /\S/.test(this.content);
	}

	replaceStringEmoji(value: string) {
		if (value === null || value === undefined || value === '' || value === ' ') {
			return value;
		}
		const emojiMap = {
			':)': '🙂',
			':(': '🙁',
			':D': '😁',
			';(': '😥',
			':\'(': '😥',
			':O': '😮',
			';)': '😉',
			'8)': '😎',
			'>:@': '😡',
			':p': '😛',
			'<3': '❤️',
			'^^': '😝'
		};

		return value.replace(new RegExp(
			Object.keys(emojiMap).map(s => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|'),
			'g'
		), match => {
			// @ts-expect-error - match is guaranteed to be a key of emojiMap
			return emojiMap[match];
		});
	}
}
